"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unbindLifeOnPage = exports.bindLifeOnPage = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const bindLifeOnPage = function (data, page, name, handle) {
    if (!page.localLife) {
        page.localLife = {};
    }
    const lifeProp = data.$getId(name);
    page.localLife[lifeProp] = data.$onLife(name, handle);
};
exports.bindLifeOnPage = bindLifeOnPage;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const unbindLifeOnPage = function (data, page, name) {
    if (!page.localLife) {
        page.localLife = {};
    }
    const lifeProp = data.$getId(name);
    const lifeId = page.localLife[lifeProp];
    if (lifeId) {
        data.$offLife(name, lifeId);
        page.localLife[lifeProp] = undefined;
    }
};
exports.unbindLifeOnPage = unbindLifeOnPage;
